import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import PageHeader from '../../components/public/PageHeader';
import { publicApi } from '../../services/api';

export default function ContactPage() {
  const [page, setPage] = useState(null);
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    Promise.all([
      publicApi.getPage('contact').catch(() => ({ data: { data: null } })),
      publicApi.getSettings().catch(() => ({ data: { data: {} } })),
    ]).then(([pageRes, settingsRes]) => {
      setPage(pageRes.data?.data || null);
      const groups = settingsRes.data?.data || {};
      const flat = {};
      Object.values(groups).forEach(group => {
        group.forEach(s => { flat[s.key] = s.value; });
      });
      setContact(flat);
    }).finally(() => setLoading(false));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHeader title={page?.title || 'Kontak Kami'} subtitle="Kami siap membantu Anda" />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center py-20"><div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>
          ) : (
            <div className="grid lg:grid-cols-3 gap-12">
              <div className="lg:col-span-2">
                {submitted ? (
                  <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
                    <span className="text-5xl mb-4 block">✅</span>
                    <h3 className="text-2xl font-bold text-green-800 mb-2">Pesan Terkirim!</h3>
                    <p className="text-green-600">Terima kasih telah menghubungi kami. Tim kami akan merespons dalam 1x24 jam.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid sm:grid-cols-2 gap-6">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Nama</label>
                        <input type="text" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none" placeholder="Nama Anda" />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                        <input type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none" placeholder="email@example.com" />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Subjek</label>
                      <input type="text" required value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none" placeholder="Subjek pesan" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Pesan</label>
                      <textarea required rows={5} value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary focus:border-transparent outline-none resize-none" placeholder="Tulis pesan Anda..." />
                    </div>
                    <button type="submit" className="bg-brand text-navy font-semibold px-8 py-3 rounded-full hover:bg-brand-dark transition-colors">Kirim Pesan</button>
                  </form>
                )}
              </div>
              <div className="space-y-6">
                <div className="bg-bg-light rounded-2xl p-6">
                  <h3 className="font-bold text-gray-900 mb-4">Info Kontak</h3>
                  <div className="space-y-4 text-sm">
                    <div className="flex items-start gap-3"><span className="text-xl">📍</span><div><p className="font-medium text-gray-700">Alamat</p><p className="text-gray-500">{contact.contact_address || 'Jl. Cemara Raya, RT.006/RW.006A, Jakasampurna, Kec. Bekasi Bar., Kota Bks, Jawa Barat 17145'}</p></div></div>
                    <div className="flex items-start gap-3"><span className="text-xl">📞</span><div><p className="font-medium text-gray-700">Telepon</p><p className="text-gray-500">{contact.contact_phone || '+62 878-6878-2477'}</p></div></div>
                    <div className="flex items-start gap-3"><span className="text-xl">📧</span><div><p className="font-medium text-gray-700">Email</p><p className="text-gray-500">{contact.contact_email || 'info@klinnovac.com'}</p></div></div>
                    <div className="flex items-start gap-3"><span className="text-xl">💬</span><div><p className="font-medium text-gray-700">WhatsApp</p><p className="text-gray-500">{contact.contact_whatsapp || '+62 878-6878-2477'}</p></div></div>
                  </div>
                </div>
                <div className="bg-gray-200 rounded-2xl h-64 flex items-center justify-center text-gray-400">
                  <div className="text-center"><span className="text-4xl block mb-2">🗺️</span><p className="text-sm">Google Maps</p></div>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}